<arcgis-map
  #map
  (arcgisViewChange)="viewChanged()"
  (arcgisViewClick)="viewClicked($event)"
  (arcgisViewPointerMove)="viewPointerMove($event)"
  (arcgisViewReadyChange)="viewReady()"
  [background]="backgroundColor()"
  [basemap]="baseLayer()"
  [center]="center()"
  [constraints]="constraints()"
  [zoom]="zoom()"
  class="outline-none"
>
  <arcgis-zoom class="absolute bottom-44 right-12"></arcgis-zoom>
</arcgis-map>

@if (stateService.hoveredListing()) {
  <app-map-listing-popover
    [listing]="stateService.hoveredListing()!"
    class="absolute top-4"
    [style.left]="listingPopoverLeft()"
    [style.top]="listingPopoverTop()"
  />
}
